// extracted by mini-css-extract-plugin
module.exports = {"container":"_2YcOi","gridContainer":"_3a7iH","headerContainer":"_26sOu","header":"_33vm9","content":"_1dayb","controls":"_2iRDp","separator":"_3JaqT"};